import Vue from 'vue'
import UtilCurrency from '@/components/utils/UtilCurrency'

Vue.component('Currency', UtilCurrency)
